export const SSAG_PATHS = require('../../shared/ssagPaths');
